/**
 * @Author: Zero
 * @Date: 2024-03-30 16:43:11
 * @Explain: 联系人管理
 */

// router
import RouterPath from '@/router/routingPath';
// type
import { SourceTypeEnum } from '@/pages/contactManage/addOrEdit/data.d';
import { LeaveTypeEnum } from '@/pages/contactManage/utils/enum/newsletter';
import { FormDataType } from '@/pages/contactManage/utils/typings/newsletter';
// utils
import { defaultForm as defaultNewsletterDetails } from '@/pages/contactManage/utils/config/newsletter';
import { isEmptyObject } from '@/utils/common/dataJudgment';

export interface ContactManageState {
  /** 新增联系人 - 来源 */
  addContectSourceType: {
    /** 来源 */
    sourceType: SourceTypeEnum;
    /** 路由 */
    path?: string;
  };
  /** 联系人 - 预约设置信息 */
  newsletterDetails: FormDataType;
  /** 联系人 - 预约设置信息状态 */
  newsletterIsDraft: LeaveTypeEnum | string;
}

export type ModelType = {
  namespace: string;
  state: ContactManageState;
  reducers: {
    setAddContectSourceType: (
      state: ContactManageState,
      action: { payload: any },
    ) => any;
    setNewsletterDetails: (
      state: ContactManageState,
      action: { payload: any },
    ) => any;
  };
};

const ContactManageModel: ModelType = {
  namespace: 'ContactManageModel',
  state: {
    addContectSourceType: {
      sourceType: SourceTypeEnum.uploadAFile,
      path: RouterPath.CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_UPLOAD_FILE,
    },
    newsletterDetails:
      // jsonParse(getLocalStorage(StoreKeyEnum.NEWSLETTER_DETAILS)) ||
      {
        ...defaultNewsletterDetails,
      },
    newsletterIsDraft:
      // getLocalStorage(StoreKeyEnum.NEWSLETTER_IS_DEAFT) ||
      LeaveTypeEnum.DEFAULT,
  },
  reducers: {
    /** 新增联系人 - 来源 */
    setAddContectSourceType(state, action) {
      return {
        ...state,
        addContectSourceType: action.payload,
      };
    },
    /** 联系人 - 预约设置信息 */
    setNewsletterDetails(state, action) {
      let newsletterDetails = action.payload;
      let newsletterIsDraft = state.newsletterIsDraft;

      if (!isEmptyObject(newsletterDetails)) {
        newsletterIsDraft = LeaveTypeEnum.DRAFT;
      } else {
        newsletterIsDraft = LeaveTypeEnum.DEFAULT;
      }

      // setLocalStorage(StoreKeyEnum.NEWSLETTER_DETAILS, newsletterDetails);
      // setLocalStorage(StoreKeyEnum.NEWSLETTER_IS_DEAFT, newsletterIsDraft);
      return {
        ...state,
        newsletterDetails,
        newsletterIsDraft,
      };
    },
  },
};

export default ContactManageModel;
